
module.exports = {
	Account: {
		AGR: require('../../schemas/regoptions/agr.json'),
		ASO: require('../../schemas/regoptions/aso.json'),
		ADM: require('../../schemas/regoptions/adm.json'),
		AUT: require('../../schemas/regoptions/aut.json'),
		INS: require('../../schemas/regoptions/ins.json'),
		SUP: require('../../schemas/regoptions/sup.json')
	},
	Animalkind: require('../../schemas/animalkind.json'),
	Animalmenu: require('../../schemas/animalmenu.json'),
	Animalusage: require('../../schemas/animalusage.json'),
	Category1: require('../../schemas/category1.json'),
	Category2: require('../../schemas/category2.json'),
	Classification: require('../../schemas/classification.json'),
	Country: require('../../schemas/country.json'),
	Offer: require('../../schemas/offer.json'),
	Offerfield: require('../../schemas/offerfield.json'),
	Offergroup: require('../../schemas/offergroup.json'),
	Region: require('../../schemas/region.json'),
	Requestformfield: require('../../schemas/requestformfield.json'),
	Requestlog: require('../../schemas/requestlog.json'),
	Requestpackage: require('../../schemas/requestpackage.json'),
	Requestprocess: require('../../schemas/requestprocess.json'),
	Settings: require('../../schemas/settings.json'),
	Upload: require('../../schemas/upload.json'),
};
